import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IPendingWhitelabelConfiguration, PendingWhitelabelConfiguration, IWhitelabelConfiguration, WhitelabelConfiguration } from '../models/whitelabel-config';

@Injectable({
  providedIn: 'root'
})
export class WhitelabelService {

  private apiEndpoint = environment.azure.whitelabel.api;
  private container = environment.azure.whitelabel.container;

  // Sem x-functions-key: quem autentica e o Bearer que o MsalInterceptor anexa automaticamente
  // (protectedResourceMap em app.module.ts) e que o EntraIdAuthenticationMiddleware do Function App
  // valida. Nao reintroduzir a key aqui -- ela vazava no bundle publico junto com o resto do
  // environment, que e a razao de ter saido.
  constructor(
    private httpClient: HttpClient) {}

  public getConfiguration(accountantId: string) {
    return this.httpClient.get<IWhitelabelConfiguration>(`${this.apiEndpoint}/GetWhitelabelConfiguration/${accountantId}`).pipe(
      map(config => new WhitelabelConfiguration(config))
    )
  }

  public saveConfigurations(configurations: WhitelabelConfiguration): Observable<WhitelabelConfiguration>  {
    return this.httpClient.post<IWhitelabelConfiguration>(`${this.apiEndpoint}/SaveWhitelabelConfigurations`, configurations).pipe(
      map(config => new WhitelabelConfiguration(config))
    )
  }

  public getPendingConfigurations(): Observable<PendingWhitelabelConfiguration[]> {
    return this.httpClient.get<IPendingWhitelabelConfiguration[]>(`${this.apiEndpoint}/PendingWhitelabelConfigurations`).pipe(
      map(pendingConfigurations => {
        return pendingConfigurations.map(config => new PendingWhitelabelConfiguration(config))
      })
    )
  }

  public getConfigurations(): Observable<WhitelabelConfiguration[]> {
    return this.httpClient.get<IWhitelabelConfiguration[]>(`${this.apiEndpoint}/GetWhitelabelConfigurations`).pipe(
      map(configurations => {
        return configurations.map(config => new WhitelabelConfiguration(config))
      })
    )
  }
}
